class SupernovaAudio extends window.BAO.CustomElement {
  constructor () {
    super()

    this.toggleAudio = this.toggleAudio.bind(this)
    this.updateEqualiser = this.updateEqualiser.bind(this)
    this.playAudio = this.playAudio.bind(this)
    this.pauseAudio = this.pauseAudio.bind(this)
    this.unPauseAudio = this.unPauseAudio.bind(this)

    this.pausedForVideo = false
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.toggle || !this.els.audio) return

    this.listeners.add(this.els.toggle.element, 'click', this.toggleAudio)
    this.listeners.add(this.els.audio.element, 'pause', this.updateEqualiser)
    this.listeners.add(this.els.audio.element, 'play', this.updateEqualiser)

    if (this.externalEls.play) {
      this.externalEls.play.elements.forEach(el => {
        this.listeners.add(el, 'click', this.playAudio)
      })
    }

    if (this.externalEls.pause) {
      this.externalEls.pause.elements.forEach(el => {
        this.listeners.add(el, 'click', this.pauseAudio)
      })
    }

    document
      .querySelectorAll('[data-el="video-modal.modal-close"]')
      .forEach(el => {
        this.listeners.add(el, 'click', this.unPauseAudio)
      })
  }

  toggleAudio (e) {
    e.preventDefault()

    if (this.isPlaying) {
      this.els.audio.element.pause()
    } else {
      this.els.audio.element.play()
    }
    this.pausedForVideo = false
  }

  playAudio () {
    this.els.audio.element.play()
  }

  pauseAudio () {
    if (this.isPlaying) {
      this.els.audio.element.pause()
      this.pausedForVideo = true
    }
  }

  unPauseAudio () {
    if (this.pausedForVideo) {
      this.els.audio.element.play()
    }
  }

  updateEqualiser () {
    this.els.equaliser.element.dataset.playing = this.isPlaying.toString()
  }

  get isPlaying () {
    return !this.els.audio.element.paused
  }
}

if (!customElements.get('supernova-audio')) {
  customElements.define('supernova-audio', SupernovaAudio)
}
